import React, { useState } from 'react';
import { LANGUAGES } from '../../utils/driverDocuments';
import { COLORS } from '../../styles/tokens';
import { sheetButtons } from '../common/SheetModal';

// Språkene sjåføren snakker. Bestiller ser dem som korte merker på sjåføren.
export default function LanguagePicker({ value = [], onSave, onClose }) {
  const [selected, setSelected] = useState(value);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');

  const toggle = (code) => setSelected(s => (s.includes(code) ? s.filter(c => c !== code) : [...s, code]));

  async function save() {
    setBusy(true); setError('');
    try {
      await onSave(LANGUAGES.map(l => l.code).filter(c => selected.includes(c)));
      onClose?.();
    } catch {
      setError('Kunne ikke lagre. Prøv igjen.');
    } finally {
      setBusy(false);
    }
  }

  return (
    <div>
      <h2 style={sheetButtons.title}>Språk jeg snakker</h2>
      <p style={sheetButtons.text}>Bestiller ser hvilke språk du snakker, så det er lett å bli forstått.</p>
      <div style={{ display: 'grid', gap: 4 }}>
        {LANGUAGES.map(l => (
          <label key={l.code} style={{ display: 'flex', gap: 10, alignItems: 'center', minHeight: 44, fontSize: 15, color: COLORS.textDark }}>
            <input type="checkbox" checked={selected.includes(l.code)} onChange={() => toggle(l.code)} />
            {l.label}
          </label>
        ))}
      </div>
      {error && <p style={{ color: COLORS.dangerText, fontSize: 13 }}>{error}</p>}
      <button type="button" style={sheetButtons.gold} disabled={busy || selected.length === 0} onClick={save}>Lagre</button>
      {onClose && <button type="button" style={sheetButtons.ghost} onClick={onClose}>Avbryt</button>}
    </div>
  );
}
